import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Style = styled.div`
  min-height: 572px;
  padding: 30px;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: center;

  .icon {
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    width: 78px;
    height: 78px;
    background: rgba(61, 142, 219, 0.15);
    border-radius: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .icon-body {
      margin-left: auto;
      margin-right: auto;
      width: 60px;
      height: 60px;
      background: rgba(61, 142, 219, 0.25);
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 100%;

      svg {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  h2 {
    font-size: var(--font-size-lg);
    font-weight: 600;
    text-align: center;
  }

  p {
    font-size: 14px;
    color: #667085;
    text-align: center;
  }

  .btn-cont {
    display: flex;
    justify-content: center;

    .ant-btn {
      border-radius: 8px;
      border-color: var(--color-primary-70);
      color: var(--color-primary-70);
    }
  }
`;

export default function EmptyState({ onCreate, conf = {} }) {
  const { t } = useTranslation();

  return (
    <Style>
      <div className="icon">
        <div className="icon-body">
          <svg width="38" height="35" viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.5853 32.8186V22.6311M25.4915 27.7249H35.679M18.6999 22.6311H11.9082C8.74368 22.6311 7.16142 22.6311 5.91331 23.1481C4.24916 23.8374 2.927 25.1596 2.23769 26.8237C1.7207 28.0718 1.7207 29.6541 1.7207 32.8186M24.6426 2.74979C27.1316 3.75731 28.8874 6.1975 28.8874 9.04777C28.8874 11.898 27.1316 14.3382 24.6426 15.3458M21.2467 9.04777C21.2467 12.7987 18.206 15.8394 14.4551 15.8394C10.7041 15.8394 7.66341 12.7987 7.66341 9.04777C7.66341 5.29684 10.7041 2.2561 14.4551 2.2561C18.206 2.2561 21.2467 5.29684 21.2467 9.04777Z" stroke="#003A70" strokeWidth="3.39583" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
      <h2>{t(conf.group === 'dataClient' ? 'No information client added' : 'No information source added')}</h2>
      <p>{t(conf.group === 'dataClient' ? 'This project is not shared with any other organisation' : 'This project contains no information')}</p>
      <div className="btn-cont">
        <Button onClick={onCreate} size="large">
          {t(conf.group === 'dataClient' ? 'Add Information Client' : 'Add Information Source')}
        </Button>
      </div>
    </Style>
  );
}
